// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  z-index: 1000;
  padding: 8px 12px;
  background-color: var(--surface-3);
  color: var(--text-primary);
  border: 1px solid var(--border-subtle);
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.4;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  animation: tooltipFadeIn 0.2s ease-out forwards;
  box-shadow: var(--shadow-md);
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Position variants */
.tooltip-top {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
}

.tooltip-top::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: var(--surface-3);
}

.tooltip-bottom {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
}

.tooltip-bottom::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-bottom-color: var(--surface-3);
}

.tooltip-left {
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 8px;
}

.tooltip-left::after {
  content: '';
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  border: 5px solid transparent;
  border-left-color: var(--surface-3);
}

.tooltip-right {
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 8px;
}

.tooltip-right::after {
  content: '';
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  border: 5px solid transparent;
  border-right-color: var(--surface-3);
}

/* Ensure tooltip doesn't go off screen on small devices */
@media (max-width: 768px) {
  .tooltip {
    max-width: 200px;
    white-space: normal;
    word-wrap: break-word;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Tooltip/Tooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kCAAkC;EAClC,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,+CAA+C;EAC/C,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA,0DAA0D;AAC1D;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;EACvB;AACF","sourcesContent":[".tooltip-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip {\n  position: absolute;\n  z-index: 1000;\n  padding: 8px 12px;\n  background-color: var(--surface-3);\n  color: var(--text-primary);\n  border: 1px solid var(--border-subtle);\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 1.4;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  animation: tooltipFadeIn 0.2s ease-out forwards;\n  box-shadow: var(--shadow-md);\n}\n\n@keyframes tooltipFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Position variants */\n.tooltip-top {\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 8px;\n}\n\n.tooltip-top::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: var(--surface-3);\n}\n\n.tooltip-bottom {\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-top: 8px;\n}\n\n.tooltip-bottom::after {\n  content: '';\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-bottom-color: var(--surface-3);\n}\n\n.tooltip-left {\n  right: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-right: 8px;\n}\n\n.tooltip-left::after {\n  content: '';\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  border: 5px solid transparent;\n  border-left-color: var(--surface-3);\n}\n\n.tooltip-right {\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-left: 8px;\n}\n\n.tooltip-right::after {\n  content: '';\n  position: absolute;\n  right: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  border: 5px solid transparent;\n  border-right-color: var(--surface-3);\n}\n\n/* Ensure tooltip doesn't go off screen on small devices */\n@media (max-width: 768px) {\n  .tooltip {\n    max-width: 200px;\n    white-space: normal;\n    word-wrap: break-word;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
